import React, { useState, useEffect } from "react";
import { FormStep, TextInput, CardLabel, Toast, SearchIcon, SubmitBar, RadioOrSelect } from "@egovernments/digit-ui-react-components";
import Timeline from "../../components/Timeline";
import { Tab, Tabs } from "@mui/material";
import TabPanel from "../TabPanel";

const ProfessionalDetails = ({ t, onSelect, formData, currStep }) => {
  let validation = {};
  sessionStorage.removeItem("currentPincode");
  let isedittrade = window.location.href.includes("edit-application");
  let isrenewtrade = window.location.href.includes("renew-trade");
  const [currentTab, setCurrentTab] = useState("1");
  const userInfo = Digit.UserService.getUser();
  const [canmovenext, setCanmovenext] = useState(isedittrade || isrenewtrade ? false : true);
  const [ownershipCategory, setOwnershipCategory] = useState(formData?.owners?.ownershipCategory);
  const [name, setName] = useState(formData[currStep.key]?.name || "");
  const [registrationNumber, setregistrationNo] = useState(formData[currStep.key]?.registrationNumber || "");
  const [emailId, setemailId] = useState(formData[currStep.key]?.emailId || "");
  const [address, setaddress] = useState(formData[currStep.key]?.address || "");
  const [district, setDistrict] = useState(formData[currStep.key]?.district || "");
  const [state, setState] = useState(formData[currStep.key]?.state || "");
  const [mobileNumber, setMobileNumber] = useState(formData[currStep.key]?.mobileNumber || "");
  const [tehsil, setTehsil] = useState(formData[currStep.key]?.tehsil || "")
  const [town, setTown] = useState(formData[currStep.key]?.town || "")
  const [pinNo, setPinNo] = useState(formData[currStep.key]?.pinNo || "")
  const [classCat, setClassCat] = useState(formData[currStep.key]?.classA || "")
  const [university, setUniversity] = useState(formData[currStep.key]?.university || "")
  const [selcectedEng, setSelectedEng] = useState(formData[currStep.key]?.selcectedEng || null);
  let Webview = !Digit.Utils.browser.isMobile();
  const ismultiple = ownershipCategory?.code.includes("MULTIPLEOWNERS") ? true : false;
  formData?.owners?.owners?.forEach(owner => {
    if (owner.isPrimaryOwner == "false") owner.isPrimaryOwner = false
  })
  const getFormEntries = (filter) => (
    (
      typeof formData[currStep.key] === 'object' &&
      !Array.isArray(formData[currStep.key])
    ) ?
      [Object.keys(formData[currStep.key])
        .filter((key) => filter(key))
        .reduce((obj, key) => {
          obj[key] = formData[currStep.key][key];
          return obj;
        }, {})] : null
  );

  const [erfields, setErFeilds] = useState(
    getFormEntries((key) => key.startsWith('er')) || [{
      ermobileNumber: selcectedEng?.mobileNumber || "",
      ername: selcectedEng?.name || "",
      erregistrationNumber: "",
      eremailId: selcectedEng?.emailId || "",
      eraddress: selcectedEng?.permanentAddress?.address || "",
      erstate: selcectedEng?.permanentAddress?.state || "",
      erdistrict: selcectedEng?.permanentAddress?.district || "",
      ertehsil: selcectedEng?.permanentAddress?.tehsil || "",
      ertown: selcectedEng?.permanentAddress?.town || "",
      erpinNo: selcectedEng?.permanentAddress?.pinNo || "",
    }]
  );
  const [ername, setErName] = useState(formData[currStep.key]?.ername || erfields.ername || "");
  const [erregistrationNumber, setErregistrationNo] = useState(formData[currStep.key]?.erregistrationNumber || erfields.erregistrationNumber || "");
  const [eremailId, setEremailId] = useState(formData[currStep.key]?.eremailId || erfields.eremailId || "");
  const [eraddress, setEraddress] = useState(formData[currStep.key]?.eraddress || erfields.eraddress || "");
  const [erdistrict, setErDistrict] = useState(formData[currStep.key]?.erdistrict || erfields.erdistrict || "");
  const [erstate, setErState] = useState(formData[currStep.key]?.erstate || erfields.erstate || "");
  const [ermobileNumber, setErMobileNumber] = useState(formData[currStep.key]?.ermobileNumber || erfields.ermobileNumber || "");
  const [ertehsil, setErTehsil] = useState(formData[currStep.key]?.ertehsil || erfields.ertehsil || "");
  const [ertown, setErTown] = useState(formData[currStep.key]?.ertown || erfields.ertown || "");
  const [erpinNo, setErPinNo] = useState(formData[currStep.key]?.erpinNo || erfields.erpinNo || "");
  const [showToast, setShowToast] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  const [error, setError] = useState(null);
  const [engineersArr, setEngsArr] = useState([])
  const [fields, setFeilds] = useState(
    getFormEntries((key) => !key.startsWith('er')) || [{
      mobileNumber: userInfo?.info?.mobileNumber || "",
      name: userInfo?.info?.name || "",
      registrationNumber: "",
      emailId: userInfo?.info?.emailId || "",
      address: "",
      state: "",
      district: "",
      tehsil: "",
      town: "",
      pinNo: "",
      classA: "",
      university: ""
    }]
  );
  function setOwnerName(i, e) {
    let units = [...fields];
    units[i].name = e.target.value;
    setName(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErOwnerName(i, e) {
    let units = [...erfields];
    units[i].name = e.target.value;
    setErName(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setRegistrationNo(i, e) {
    let units = [...fields];
    units[i].registrationNumber = e.target.value;
    setregistrationNo(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErRegistrationNo(i, e) {
    let units = [...erfields];
    units[i].registrationNumber = e.target.value;
    setErregistrationNo(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setAddress(i, e) {
    let units = [...fields];
    units[i].address = e.target.value;
    setaddress(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErAddress(i, e) {
    let units = [...erfields];
    units[i].address = e.target.value;
    setEraddress(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectEmail(i, e) {
    let units = [...fields];
    units[i].emailId = e.target.value;
    setemailId(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErEmail(i, e) {
    let units = [...erfields];
    units[i].emailId = e.target.value;
    setEremailId(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectDistrict(i, e) {
    let units = [...fields];
    units[i].district = e.target.value;
    setDistrict(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErDistrict(i, e) {
    let units = [...erfields];
    units[i].district = e.target.value;
    setErDistrict(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectTehsil(i, e) {
    let units = [...fields];
    units[i].tehsil = e.target.value;
    setTehsil(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErTehsil(i, e) {
    let units = [...erfields];
    units[i].tehsil = e.target.value;
    setErTehsil(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectTown(i, e) {
    let units = [...fields];
    units[i].town = e.target.value;
    setTown(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErTown(i, e) {
    let units = [...erfields];
    units[i].town = e.target.value;
    setErTown(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectPinNO(i, e) {
    let units = [...fields];
    units[i].pinNo = e.target.value;
    setPinNo(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErPinNO(i, e) {
    let units = [...erfields];
    units[i].pinNo = e.target.value;
    setErPinNo(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }

  function selectClassCat(i, e) {
    let units = [...fields];
    units[i].classA = e.target.value;
    setClassCat(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectUniversity(i, e) {
    let units = [...fields];
    units[i].university = e.target.value;
    setUniversity(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }


  function selectState(i, e) {
    let units = [...fields];
    units[i].state = e.target.value;
    setState(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErState(i, e) {
    let units = [...erfields];
    units[i].state = e.target.value;
    setErState(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }

  function setMobileNo(i, e) {
    let units = [...fields];
    units[i].mobileNumber = e.target.value;
    setMobileNumber(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErMobileNo(i, e) {
    let units = [...erfields];
    units[i].mobileNumber = e.target.value;
    setErMobileNumber(e.target.value);
    setErFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  useEffect(async () => {
    const tenantId = Digit.ULBService.getStateId()
    const structualEngResponse = await Digit.UserService.userSearch(tenantId, { roleCodes: ["BPA_STRUCTURALENGINEER"]});
    setEngsArr(structualEngResponse?.user)
}, [])

  /////////////Viresh Doc 07-11-2023//////////////
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const goNext = () => {
    const professionaldetail = {}
    professionaldetail.registrationNumber = registrationNumber || "";
    professionaldetail.name = name || ""
    professionaldetail.mobileNumber = mobileNumber || ""
    professionaldetail.address = address || ""
    professionaldetail.state = state || "";
    professionaldetail.district = district || ""
    professionaldetail.tehsil = tehsil || ""
    professionaldetail.town = town || "";
    professionaldetail.pinNo = pinNo || ""
    professionaldetail.emailId = emailId || ""
    professionaldetail.classA = classCat || "";
    professionaldetail.university = university || ""
    professionaldetail.erregistrationNumber = erfields?.[0]?.erregistrationNumber || ""
    professionaldetail.ername = ername || erfields?.[0]?.ername || ""
    professionaldetail.ermobileNumber = ermobileNumber || erfields?.[0]?.ermobileNumber || ""
    professionaldetail.eraddress = eraddress || erfields?.[0]?.eraddress || ""
    professionaldetail.erstate = erstate || erfields?.[0]?.erstate || "";
    professionaldetail.erdistrict = erdistrict || erfields?.[0]?.erdistrict || ""
    professionaldetail.ertehsil = ertehsil || erfields?.[0]?.ertehsil || ""
    professionaldetail.ertown = ertown || erfields?.[0]?.ertown || "";
    professionaldetail.erpinNo = erpinNo || erfields?.[0]?.erpinNo || ""
    professionaldetail.eremailId = eremailId || erfields?.[0]?.eremailId || ""
    professionaldetail.engineerUuid = erfields?.[0]?.eruuid || ""

    if (currentTab == "1") {
      setCurrentTab("2")
      return;
    }
    onSelect(currStep.key, professionaldetail);
  };
  const onSkip = () => onSelect();

  return (
    <div>
      <Timeline currentStep={currStep.step} flow="Form26" />
      <FormStep onSelect={goNext} onSkip={onSkip}
        t={t}
        isDisabled={canmovenext || isDisable} forcedError={t(error)}
        cardStyle={{ margin: '1.25rem auto 2rem' }}
      >
        <Tabs value={currentTab} onChange={handleChange}>
          {currStep.tabList.map((tab, index) => (
            <Tab label={`${t(tab)}`} value={`${index + 1}`} sx={{ textTransform: 'none', p: '0 1rem' }} />
          ))}
        </Tabs>
        <TabPanel value={currentTab} index="1" sx={{ p: 0 }}>
          {fields.map((field, index) => {
            return (
              <div key={`${field}-${index}`}>
                <div style={{ border: "solid", borderRadius: "5px", padding: "20px 20px 0", marginTop: "10px", borderColor: "#f3f3f3", background: "#FAFAFA" }}>
                  <CardLabel style={{ marginBottom: "-15px" }}>{`${t("CORE_COMMON_MOBILE_NUMBER")} *`}</CardLabel>
                  <div style={{ marginTop: "30px" }}>
                    <div className="field-container">
                      <div style={{ position: "relative", zIndex: "100", left: "35px", marginTop: "-24.5px", marginLeft: Webview ? "-25px" : "-25px" }}>+91</div>
                      <TextInput
                        style={{ background: "#FAFAFA", padding: "0px 35px" }}
                        type={"text"}
                        t={t}
                        isMandatory={false}
                        optionKey="i18nKey"
                        name="mobileNumber"
                        value={field.mobileNumber}
                        onChange={(e) => setMobileNo(index, e)}
                        {...(validation = {
                          isRequired: true,
                          pattern: "[6-9]{1}[0-9]{9}",
                          type: "tel",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />
                      <div style={{ position: "relative", zIndex: "100", right: "35px", marginTop: "-24px", marginRight: Webview ? "-20px" : "-20px" }} onClick={(e) => getOwnerDetails(index, e)}> <SearchIcon /> </div>
                    </div>
                  </div>
                  <CardLabel>{`${t("CORE_COMMON_NAME")} *`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="name"
                    value={field.name}
                    onChange={(e) => setOwnerName(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{`${t("CORE_COMMON_REGISTRATION_NUMBER")} *`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="registrationNumber"
                    value={field.registrationNumber}
                    onChange={(e) => setRegistrationNo(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{t("BPA_APPLICANT_EMAIL_LABEL") + "*"}</CardLabel>
                  <TextInput
                    t={t}
                    type={"email"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="emailId"
                    value={field.emailId}
                    onChange={(e) => selectEmail(index, e)}
                    //disable={editScreen}
                    {...{ required: true, pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$", type: "email", title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID") }}
                  />
                  <CardLabel>{`${t("CORE_COMMON_ADDRESS")}`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="registrationNumber"
                    value={field.address}
                    onChange={(e) => setAddress(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{`${t("CORE_COMMON_STATE")}`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="state"
                    value={field.state}
                    onChange={(e) => selectState(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />

                  <CardLabel>{t("CORE_COMMON_DISTRICT")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="district"
                    value={field.district}
                    onChange={(e) => selectDistrict(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />

                  <CardLabel>{t("CORE_COMMON_TEHSIL")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="tehsil"
                    value={field.tehsil}
                    onChange={(e) => selectTehsil(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}

                  />
                  <CardLabel>{t("CORE_COMMON_TOWN")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="town"
                    value={field.town}
                    onChange={(e) => selectTown(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                  <CardLabel>{t("CORE_COMMON_PINNO")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="pinNo"
                    value={field.pinNo}
                    onChange={(e) => selectPinNO(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                  <CardLabel>{t("CORE_COMMON_CLASS_CATEGORIES")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="classA"
                    value={field.classA}
                    onChange={(e) => selectClassCat(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                  <CardLabel>{t("CORE_COMMON_UNIVERSITY_NAME")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="university"
                    value={field.university}
                    onChange={(e) => selectUniversity(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                </div>
              </div>
            );
          })}

        </TabPanel>
        <TabPanel value={currentTab} index="2" sx={{ p: 0 }}>

          {erfields.map((field, index) => {
            return (
              <div key={`${field}-${index}`}>
                <div style={{ border: "solid", borderRadius: "5px", padding: "20px 20px 0", marginTop: "10px", borderColor: "#f3f3f3", background: "#FAFAFA" }}>
                                      <CardLabel variant="h6">{`${t("BPA_SELECT_STRUCTURAL_ENGINEER_LABEL")}`}</CardLabel>
                                        <RadioOrSelect
                                        name="engineerType"
                                        optionKey="name"
                                        options={engineersArr}
                                        onSelect={(name) => {
                                            setSelectedEng(name)
                                            setErFeilds([{
                                              ermobileNumber: name?.mobileNumber || "",
                                              ername: name?.name || "",
                                              erregistrationNumber: "",
                                              eremailId: name?.emailId || "",
                                              eraddress: name?.permanentAddress?.address || "",
                                              erstate: name?.permanentAddress?.state || "",
                                              erdistrict: name?.permanentAddress?.district || "",
                                              ertehsil: name?.permanentAddress?.tehsil || "",
                                              ertown: name?.permanentAddress?.town || "",
                                              erpinNo: name?.permanentAddress?.pinNo || "",
                                              eruuid: name?.uuid || ""
                                            }])
                                        }}
                                        selectedOption={selcectedEng}
                                        t={t}
                                        />
                  <CardLabel style={{ marginBottom: "-15px" }}>{`${t("CORE_COMMON_MOBILE_NUMBER")} *`}</CardLabel>
                  <div style={{ marginTop: "30px" }}>
                    <div className="field-container">
                      {/* <div style={{ position: "relative", zIndex: "100", left: "35px", marginTop: "-24.5px", marginLeft: Webview ? "-25px" : "-25px" }}>+91</div> */}
                      <TextInput
                        style={{ background: "#FAFAFA"}}
                        type={"text"}
                        t={t}
                        isMandatory={false}
                        optionKey="i18nKey"
                        name="ermobileNumber"
                        value={field.ermobileNumber || ermobileNumber}
                        onChange={(e) => setErMobileNo(index, e)}
                        {...(validation = {
                          isRequired: true,
                          pattern: "[6-9]{1}[0-9]{9}",
                          type: "tel",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />
                      <div style={{ position: "relative", zIndex: "100", right: "35px", marginTop: "-24px", marginRight: Webview ? "-20px" : "-20px" }} onClick={(e) => getOwnerDetails(index, e)}> <SearchIcon /> </div>
                    </div>
                  </div>
                  <CardLabel>{`${t("CORE_COMMON_NAME")} *`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="ername"
                    value={ername || field.ername}
                    onChange={(e) => setErOwnerName(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{`${t("CORE_COMMON_REGISTRATION_NUMBER")} *`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="erregistrationNumber"
                    value={erregistrationNumber || field.erregistrationNumber}
                    onChange={(e) => setErRegistrationNo(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{t("BPA_APPLICANT_EMAIL_LABEL") + "*"}</CardLabel>
                  <TextInput
                    t={t}
                    type={"email"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="eremailId"
                    value={eremailId || field.eremailId}
                    onChange={(e) => selectErEmail(index, e)}
                    //disable={editScreen}
                    {...{ required: true, pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$", type: "email", title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID") }}
                  />
                  <CardLabel>{`${t("CORE_COMMON_ADDRESS")}`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="eraddress"
                    value={eraddress || field.eraddress}
                    onChange={(e) => setErAddress(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{`${t("CORE_COMMON_STATE")}`}</CardLabel>
                  <TextInput
                    style={{ background: "#FAFAFA" }}
                    t={t}
                    type={"text"}
                    isMandatory={false}
                    optionKey="i18nKey"
                    name="erstate"
                    value={erstate || field.erstate}
                    onChange={(e) => selectErState(index, e)}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      type: "text",
                      title: t("TL_NAME_ERROR_MESSAGE"),
                    })}
                  />
                  <CardLabel>{t("CORE_COMMON_DISTRICT")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="erdistrict"
                    value={erdistrict || field.erdistrict}
                    onChange={(e) => selectErDistrict(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                  <CardLabel>{t("CORE_COMMON_TEHSIL")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="ertehsil"
                    value={ertehsil || field.ertehsil}
                    onChange={(e) => selectErTehsil(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                  <CardLabel>{t("CORE_COMMON_TOWN")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="ertown"
                    value={ertown || field.ertown}
                    onChange={(e) => selectErTown(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                  <CardLabel>{t("CORE_COMMON_PINNO")}</CardLabel>
                  <TextInput
                    t={t}
                    type={"text"}
                    isMandatory={true}
                    optionKey="i18nKey"
                    name="erpinNo"
                    value={erpinNo || field.erpinNo}
                    onChange={(e) => selectErPinNO(index, e)}
                    //disable={editScreen}
                    {...(validation = {
                      isRequired: true,
                      pattern: "^[a-zA-Z-.`' ]*$",
                      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                    })}
                  />
                </div>
              </div>
            );
          })}
        </TabPanel>
        <SubmitBar label={t(`CS_COMMON_NEXT`)} onSubmit={goNext} />
      </FormStep>
      {showToast && <Toast
        error={showToast?.error}
        warning={showToast?.warning}
        label={t(showToast?.message)}
        isDleteBtn={true}
        onClose={closeToast}
      />
      }
    </div>
  );
};

export default ProfessionalDetails;
